<template>
  <div class="sidebar">

    <!-- 左上角返回工作台按钮 -->
    <div class="back-workbench-btn" @click="goToWorkbench">
      <span class="icon">←</span>
      <span class="text">返回工作台</span>
    </div>

    <el-menu
      class="el-menu-vertical-demo"
      v-bind:uniqueOpened="true"
      :default-active="menuHighLight"
      v-on:select="select"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <div :key="menu.url + '-' + menu.menuCode" v-for="menu in elearningMenuData">
        <el-submenu v-bind:index="menu.url + '-' + menu.menuCode" v-if="menu.hasSubMenu">
          <template slot="title">
            <img class="custom-icon" alt="" :src="'../../../static/icons/sidebar/' + menu.icon + '.png'" />
<!--              {{ menu.menuCode }}-->
            <span>{{ menu.menuName }}</span>
          </template>
          <el-menu-item-group
            :key="subMenu.url + '-' + subMenu.menuCode"
            v-for="subMenu in menu.subMenuList"
          >
            <el-menu-item v-bind:index="subMenu.url + '-' + subMenu.menuCode">{{
              subMenu.menuName
            }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-menu-item v-bind:index="menu.url + '-' + menu.menuCode" v-else>
<!--          <i v-bind:class="menu.icon"></i>-->
          <img class="custom-icon" alt="" :src="'../../../static/icons/sidebar/' + menu.icon + '.png'" />
<!--          <span>{{ menu.menuCode }}</span>-->
          <span slot="title">{{ menu.menuName }}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>
<script>
import router from "../../router";

export default {
  name: "SideBar",
  data() {
    return {
      elearningMenuData: [
        {
          menuId: 11,
          menuName: "菜单名称",
          icon: "",
          url: "homeTotal",
          hasSubMenu: false,
          subMenuList: [],
        },
      ],
    };
  },
  mounted() {
    this.initMenu();
  },
  computed: {
    menuTitle() {
      return this.$store.getters.menuTitle;
    },
    menuHighLight() {
      return this.$store.getters.menuHighLight;
    }
  },
  methods: {
    initMenu() {
      let elearningMenuData = JSON.parse(localStorage.getItem("elearningMenuData"));
      this.elearningMenuData = elearningMenuData;
      console.log('this.elearningMenuData', this.elearningMenuData)
      // this.elearningMenuData.push({
      //   menuId: "offlineCourse",
      //   menuName: "线下课程管理",
      //   icon: "",
      //   url: "",
      //   hasSubMenu: true,
      //   subMenuList: [
      //     {
      //       menuId: "offlineCourseCreate",
      //       menuName: "创建新课程",
      //       icon: "",
      //       url: "offlineCourseCreate",
      //       hasSubMenu: false,
      //       subMenuList: [],
      //     },
      //     {
      //       menuId: "offlineCourseOn",
      //       menuName: "已上架课程",
      //       icon: "",
      //       url: "offlineCourseOn",
      //       hasSubMenu: false,
      //       subMenuList: [],
      //     },
      //     {
      //       menuId: "offlineCourseOff",
      //       menuName: "已下架课程",
      //       icon: "",
      //       url: "offlineCourseOff",
      //       hasSubMenu: false,
      //       subMenuList: [],
      //     },
      //     {
      //       menuId: "offlineCoursePermission",
      //       menuName: "权限设置",
      //       icon: "",
      //       url: "offlineCoursePermission",
      //       hasSubMenu: false,
      //       subMenuList: [],
      //     },
      //   ],
      // });
      // this.select("competitionManage")

      // this.elearningMenuData.push({
      //       menuId: "signInTask",
      //       menuName: "签到日历任务设置",
      //       icon: "",
      //       url: "signInTask",
      //       hasSubMenu: false,
      //       subMenuList: [],
      // })
    },
    select(key) {
      let [menuKey, menuCode] = key.split('-');
      this.$router.push({ path: `/pages/${menuKey}`, query: { menuCode: menuCode, ut: Date.now() } });
      // this.$store.commit("setMenuTitle", key);
      this.$store.commit("setMenuHighLight", key);
    },
    goToWorkbench() {
      window.location.replace("https://store.lingshutong.cn/retailink-management#/desktop")
    },
  },
};
</script>
<style lang="sass" scoped>
.sidebar
  width: 200px
  height: 100%
  position: fixed
  background: #272727
  overflow: auto
  overflow-x: hidden
  .el-menu
    border-right: 0
  .logo
    width: 100%
  .custom-icon
    margin-right: 8px
    width: 20px
    height: 20px
.back-workbench-btn
    display: flex
    align-items: center
    gap: 12px
    padding: 12px 24px
    color: #fff
    cursor: pointer
    border-bottom: 1px solid #333
    transition: background 0.2s
    &:hover
      background: #333
    .icon
      font-size: 18px
    .text
      font-size: 18px
</style>





// WEBPACK FOOTER //
// src/pages/layout/SideBar.vue